import { createSelectedHook } from '@core/utils/createSelectedHook';
import { selectSelectedCornerRadius } from '@redux/slices/cornerRadiiSlice';

import { useCornerRadii } from './useCornerRadii';

export const useSelectedCornerRadius = createSelectedHook({
    selector: selectSelectedCornerRadius,
    apiQueryHook: useCornerRadii,
    shouldReturnDefault: ({ selectedValue, apiHookResponse }) => {
        const isListedInApiReturnedCornerRadii = apiHookResponse.cornerRadii.find(
            (cornerRadius) => cornerRadius.productId === selectedValue?.productId
        );

        return !isListedInApiReturnedCornerRadii || !selectedValue;
    },
    selectDefaultValue: () => undefined, // leave the default undefined - we want to have no selected corner radius sometimes
});
